import React from 'react'
import { useIntl } from 'react-intl'
import { dateFormat, timeFormat } from 'commons/date'
import { isReminded } from './CancelReminderButton'
import momentTimezone from 'moment-timezone'
import moment from 'moment'
import * as R from 'ramda'

const ReminderTime = ({ reminderDateTime, reminderTimezone }) => {
  const { formatMessage } = useIntl()
  const date = R.isNil(reminderTimezone)
    ? moment().format(dateFormat)
    : momentTimezone(reminderDateTime).tz(reminderTimezone).format(dateFormat)
  const time = R.isNil(reminderTimezone)
    ? moment().format(timeFormat)
    : momentTimezone(reminderDateTime).tz(reminderTimezone).format(timeFormat)
  const offsets = momentTimezone.tz(reminderTimezone).format('Z')

  return formatMessage(
    {
      id: isReminded(reminderDateTime)
        ? 'notificationTimeline.card.remindedDate'
        : 'notificationTimeline.card.reminderDate',
    },
    { time, date, offsets },
  )
}

export default React.memo(ReminderTime)
